// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__-pwzm","information":"style_information__Jjm-D","subTitle":"style_subTitle__3udvd","hideMargin":"style_hideMargin__2nuBW"};